import { Subject } from "rxjs";
import { ValidationRuleController } from "~app/common/validation/ValidationRuleController";
import { RaskDataChanged } from "./rask-data-changed";

export type RaskColumnTypes = "text" | "number" | "selector" | "treeselector" | "checkbox" | "button" | "link" | "span" | "icon" | "multiselector" | "sref";

type FooterAggType = "sum" | "avg" | "min" | "max";

export enum RaskColumnButtonTypes {
    "delete",
    "save",
    "copy",
    "menu",
    "edit",
    "forward"
}

export class RaskColumn {
    field: string;
    headerName: string;
    editable: boolean;
    disabled: boolean;
    type: RaskColumnTypes;
    rule: ValidationRuleController;
    values: any[];
    value: any;
    sortable: boolean;
    sortComparator?: ((valueA, valueB, nodeA, nodeB, isInverted) => number);
    width?: number;
    initialWidth?: number;
    actualWidth?: number;
    maxWidth?: number;
    minWidth?: number;
    placeholder: string | ((item: any) => string);
    filter: boolean | string;
    filterParams: any;
    text: string;
    onClick: any;
    renderedWidth: number;
    buttonType?: (RaskColumnButtonTypes | ((item: any) => RaskColumnButtonTypes));
    viewFormatter?: ((item: any) => string);
    formatter?: ((item: any) => any);
    comparePredicate?: (a, b) => boolean;
    multiselectorBindLabel?: string;
    multiselectorBindValue?: string;
    readonly: boolean | ((item: any) => boolean);
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    cellStyle?: {} | ((params: any) => {});
    cellClassRules?: {
        [cssClassName: string]: (((params: ICellClassParams) => void) | string);
    };
    footerText: string;
    footerAgg: FooterAggType | ((sum, row) => any);
    dataChanged: Subject<RaskDataChanged>;
    headerParams?: {
        iconClass?: string;
        popoverMessage?: string;
        tooltipText?: string;
    };
    resizable?: boolean;
    tooltipGenerator: (row, value) => string;
    hide: boolean;
    rowDrag?: boolean;
    tooltipComponent?: string;
    componentOptions?: (row) => any;
    children?: RaskColumn[];
}

interface ICellClassParams {
    colDef: any;
    value: any;
}
